import axios from 'axios'

export default {

    get: function (params) {
        return axios.get('/api/schools', { params });
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/schools.js